import * as React from "react";
import { filterChoices } from "./../../common/services/Filters";
import Sections from "./../../common/containers/Sections";
import SelectYear from "./../../common/containers/SelectYear";
import SelectReport from "./../containers/SelectReport";
import DrillableFilterLink from "./../../common/containers/DrillableFilterLink";
import ClearReset from "../containers/ClearReset";

export interface Props {
  onDrillDown: (sectionName: string) => void;
}

const Filters = ({ onDrillDown }: Props) => {
  const onDrillDownClick = (sectionName: string) => {
    onDrillDown(sectionName);
  };

  return (
    <React.Fragment>
      <div className="ds-l-row filterPanelTop">
        <div className="ds-l-col--12">
          <SelectReport />
        </div>
        

        <div className="ds-l-col--6">
          <SelectYear
            label="Start Date"
            filterName="selectedStartDate"
            yearList={filterChoices["histYearChoices"]}
          />
        </div>

        <div className="ds-l-col--6 ds-u-margin-left--auto">
          <SelectYear
            label="End Date"
            filterName="selectedEndDate"
            yearList={filterChoices["histYearChoices"]}
          />
        </div>
        <div className="ds-l-col--12">
        <DrillableFilterLink
            filterPanelDetailSectionName="Locations by States &amp; Territories"
            filterName="selectedStates"
            onClick={onDrillDownClick}
          />
          </div>
        </div>
        <div className="ds-l-row filterPanelBottom">
        <div className="ds-l-col--6 screenOnly">
          <ClearReset buttonType="clear"/>
        </div>
        <div className="ds-l-col--6 screenOnly">
          <ClearReset buttonType="reset"/>
        </div>
        <div className="ds-l-col--12">
        
          <div className="screenOnly">
            <h2
              className="ds-u-margin-top--2 ds-u-color--base"
              id="select-report-id"
            >
              Select Report Filters
            </h2>
          </div>
          <Sections
            onDrilldown={onDrillDown}
          />
        </div>
        </div>
    </React.Fragment>
  );
};

export default Filters;
